import {
  ChatBubbleLeftEllipsisIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

const API = process.env.REACT_APP_API_URL;

// Message types the web can send. Mirrors server/src/utils/messageTypes.js:
// a BOLO always needs guards to confirm it.
const MESSAGE_TYPES = {
  general: {
    label: "General",
    icon: ChatBubbleLeftEllipsisIcon,
    requiresAck: false,
  },
  bolo: {
    label: "BOLO",
    icon: ExclamationTriangleIcon,
    requiresAck: true,
  },
};

const TYPE_OPTIONS = Object.entries(MESSAGE_TYPES).map(([value, t]) => ({
  value,
  text: t.label,
}));

const SUBJECT_OPTIONS = [
  { value: "person", text: "Person" },
  { value: "vehicle", text: "Vehicle" },
  { value: "other", text: "Other" },
];

// 15-minute steps on the 24-hour clock ("00:00" ... "23:45"), in the
// { id, name } shape MultiSelect expects.
const TIME_OPTIONS = Array.from({ length: 96 }, (_, i) => {
  const value = `${String(Math.floor(i / 4)).padStart(2, "0")}:${String((i % 4) * 15).padStart(2, "0")}`;
  return { id: value, name: value };
});

const pad = (n) => String(n).padStart(2, "0");

// Local "YYYY-MM-DD" for a date.
const toDateInput = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// "Oct 17, 14:32" on the 24-hour clock.
const formatDateTime = (value) =>
  value
    ? new Date(value).toLocaleString([], {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      })
    : "";

export {
  API,
  MESSAGE_TYPES,
  TYPE_OPTIONS,
  SUBJECT_OPTIONS,
  TIME_OPTIONS,
  toDateInput,
  formatDateTime,
};
